import Hero from "../components/Hero";
import FeaturedProducts from "../components/FeaturedProducts";
import Contact from "../components/Contact";

const HomePage = () => {
  return (
    <main>
      <Hero />
      <FeaturedProducts />
      <Contact />
    </main>
  );
};

export default HomePage;
